module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bold-webfont.f1a41365.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bold-webfont.ttf
// module id = 382
// module chunks = 3